import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import client, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2 } from "lucide-react";

export default function ParentLogin() {
  const { user, login } = useApp();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const [brand, setBrand] = useState({});

  useEffect(() => { client.get("/settings/public").then((r) => setBrand(r.data)).catch(() => {}); }, []);
  useEffect(() => { if (user?.role === "parent") nav("/parent/dashboard"); }, [user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      const u = await login(email, password);
      if (u.role !== "parent") { setErr("This portal is for parent accounts only."); return; }
      nav("/parent/dashboard");
    } catch (e) { setErr(apiError(e)); } finally { setLoading(false); }
  };

  const bg = brand.portal_bg_url || brand.login_bg_url || "/login-bg.jpg";
  const logo = brand.logo_url || "/logo.png";
  const name = brand.academy_name || "Touzani Elite Academy";

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-6 bg-[#0F172A] overflow-auto">
      <img src={bg} alt="" className="absolute inset-0 w-full h-full object-cover z-0" />
      <div className="absolute inset-0 bg-[#0F172A]/85 backdrop-blur-[2px] z-0" />
      <div className="relative z-10 w-full max-w-md bg-background rounded-2xl shadow-2xl p-8" data-testid="parent-login-card">
        <div className="text-center mb-6">
          <img src={logo} alt={name} className="h-16 w-16 object-contain mx-auto mb-3" />
          <h1 className="text-2xl font-extrabold font-heading">{name}</h1>
          <p className="text-muted-foreground text-sm mt-1">Parent Portal</p>
        </div>
        {err && <div className="mb-4 text-sm text-rose-600 bg-rose-500/10 border border-rose-500/30 rounded-lg px-3 py-2" data-testid="parent-login-error">{err}</div>}
        <form onSubmit={submit} className="space-y-4">
          <div><Label className="mb-1.5 block">Academy Email</Label><Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="parent-login-email" placeholder="parent.name@touzanielite.academy" /></div>
          <div><Label className="mb-1.5 block">Password</Label><Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="parent-login-password" placeholder="••••••••" /></div>
          <Button type="submit" disabled={loading} className="w-full bg-emerald-600 hover:bg-emerald-700 text-white h-11" data-testid="parent-login-submit">
            {loading ? <Loader2 className="animate-spin" size={18} /> : "Sign In"}
          </Button>
        </form>
        <p className="text-xs text-muted-foreground text-center mt-6">Academy staff? <a href="/login" className="text-emerald-600 font-medium">Staff login</a></p>
      </div>
    </div>
  );
}
